import React from "react";
import { Quote, Star } from "lucide-react";

const items = [
  {
    quote:
      "I had tried diets for 8 years. With Dr. Shalini's Mounjaro programme I lost 14 kgs in 5 months — and finally feel in control of food.",
    name: "Anitha R.",
    detail: "Software Architect · Madhapur",
    loss: "−14 kg",
  },
  {
    quote:
      "What I valued most was how carefully she titrated the dose. No nausea by week 3, A1c down from 7.8 to 6.1.",
    name: "Ravi K.",
    detail: "Type 2 Diabetes · KPHB",
    loss: "−11 kg",
  },
  {
    quote:
      "Honest, no pressure, no false promises. The WhatsApp follow‑ups made all the difference.",
    name: "Sneha M.",
    detail: "PCOS · Kondapur",
    loss: "−18 kg",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FCE9E2] px-3.5 py-1.5 text-xs font-semibold text-[#B84E38]">
            Patient stories
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
            Quiet wins, from real people.
          </h2>
          <p className="mt-5 text-[#38312C] leading-relaxed">
            We don't publish dramatic before/after reels. What stays constant is standard of care.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          {items.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="rounded-3xl border border-[#EAE7E1] p-7 bg-[#FAFAF7] hover:-translate-y-1 transition-transform"
            >
              <div className="flex items-center justify-between">
                <Quote className="h-5 w-5 text-[#EB8771]" strokeWidth={1.8} />
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#779D7C] bg-[#E8F0E9] px-3 py-1 rounded-full">
                  {t.loss}
                </span>
              </div>
              <p className="font-display text-xl text-[#242220] mt-5 leading-snug">"{t.quote}"</p>
              <div className="mt-5 pt-4 border-t border-[#EAE7E1] flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-[#242220]">{t.name}</p>
                  <p className="text-xs text-[#6B6660] mt-0.5">{t.detail}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className="h-3.5 w-3.5 fill-[#EB8771] text-[#EB8771]" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
